// extracted by mini-css-extract-plugin
export default {"ImgLink":"imgLink_ImgLink__niLqe","a":"imgLink_a__ysWXA","img":"imgLink_img__riNTR"};